export default {
    None: "None",
    SupplierCheck: "SupplierCheck",
    SupplierSignatory: "SupplierSignatory",
    IpsCheck: "IpsCheck",
    IpsSignatory: "IpsSignatory"
}